import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentLoginInfoRequestModel, UpdatePaymentLoginInfoResponseModel } from "@/features/accounts/payment/scraping/services/update-login-info-model";
import { Timeout } from "@/shared/services/http-client";

export class UpdatePaymentLoginInfoApi {
  /**
   * MoneyLook ログイン情報変更API
   */
  public updatePaymentLoginInfo = async (
    param: UpdatePaymentLoginInfoRequestModel
  ): Promise<UpdatePaymentLoginInfoResponseModel> => {
    const path = `/api/paymentaccounts/scraping/updatelogininfo`;
    const res = await ApiClient.instance.post<UpdatePaymentLoginInfoResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
